import { Dribbble as Behance, Instagram, Linkedin } from 'lucide-react';
import { Instagram as InstagramIcon, Linkedin as LinkedinIcon, Dribbble } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[0, 1, 2, 3].map(i => <li key={i} data-index={i}>
            <div className="h-5 w-32 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="font-default text-[18px] text-foreground hover:text-primary transition-colors relative inline-block after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-primary hover:after:w-full after:transition-all after:duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const exploreLinks = [{
  label: "Home",
  href: "/HomePage"
}, {
  label: "The Portfolio",
  href: "/PortfolioPage"
}, {
  label: "Signature Experiences",
  href: "/SignatureExperiencesPage"
}, {
  label: "The Bridal Suite",
  href: "/BridalSuitePage"
}];
const serviceLinks = [{
  label: "Bridal Artistry",
  href: "/SignatureExperiencesPage"
}, {
  label: "Editorial Styling",
  href: "/SignatureExperiencesPage"
}, {
  label: "Event Makeup",
  href: "/SignatureExperiencesPage"
}, {
  label: "Private Lessons",
  href: "/SignatureExperiencesPage"
}, {
  label: "Bridal Consultations",
  href: "/BridalSuitePage"
}, {
  label: "On-Site Services",
  href: "/SignatureExperiencesPage"
}];
const contactLinks = [{
  label: "hello@joanneglow.com",
  href: "mailto:hello@joanneglow.com"
}, {
  label: "+1 (555) 234-5678",
  href: "tel:+15552345678"
}, {
  label: "Studio Location",
  href: "/GetInTouchPage"
}, {
  label: "New York, NY",
  href: "/GetInTouchPage"
}, {
  label: "By Appointment Only",
  href: "/GetInTouchPage"
}];
const socials = [{
  name: "Instagram",
  href: "#",
  icon: "instagram"
}, {
  name: "LinkedIn",
  href: "#",
  icon: "linkedin"
}, {
  name: "Behance",
  href: "#",
  icon: "behance"
}];
export default function Footer() {
  return <section data-section-id="2386" id="footer" className="dark relative bg-background text-foreground overflow-hidden pt-[120px] pb-10">
      {}
      <div aria-hidden="true" className="pointer-events-none select-none absolute inset-0 flex items-end justify-center overflow-hidden">
        <span className="font-default font-light tracking-tight leading-none" style={{
        color: "var(--muted)",
        opacity: 0.15,
        fontSize: "clamp(180px, 28vw, 480px)",
        transform: "translateY(15%)",
        letterSpacing: "-0.05em"
      }}>
          GLOW
        </span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-7 gap-12 lg:gap-16">
          {}
          <div className="lg:col-span-4 flex flex-col">
            <Link to="/" className="inline-block mb-8">
              <WvcLogo className="h-8 w-auto" />
            </Link>

            <p className="font-default italic text-2xl lg:text-3xl leading-snug max-w-md text-foreground mb-10">
              Elevating natural beauty through editorial precision and bridal grace.
            </p>

            <div className="flex items-center gap-3 mt-auto">
              {socials.map((social, i) => <Link key={social.name} data-index={i} to={social.href} aria-label={social.name} className="group flex items-center justify-center h-11 w-11 rounded-lg border border-border bg-card hover:bg-primary hover:border-primary transition-all duration-300">
                  {social.icon === "instagram" && <InstagramIcon className="h-4 w-4 text-foreground group-hover:text-primary-foreground transition-colors" strokeWidth={1.25} />}
                  {social.icon === "linkedin" && <LinkedinIcon className="h-4 w-4 text-foreground group-hover:text-primary-foreground transition-colors" strokeWidth={1.25} />}
                  {social.icon === "behance" && <Dribbble className="h-4 w-4 text-foreground group-hover:text-primary-foreground transition-colors" strokeWidth={1.25} />}
                </Link>)}
            </div>
          </div>

          {}
          <div className="lg:col-span-1">
            <h3 className="font-default text-xs uppercase tracking-[0.18em] text-muted-foreground mb-6">
              Explore
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
            {}
            <ul className="space-y-3 mt-3 hidden">
              {exploreLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="font-default text-[18px] text-foreground">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-1">
            <h3 className="font-default text-xs uppercase tracking-[0.18em] text-muted-foreground mb-6">
              Services
            </h3>
            <ul className="space-y-3">
              {serviceLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="font-default text-[18px] text-foreground hover:text-primary transition-colors relative inline-block after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-primary hover:after:w-full after:transition-all after:duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:col-span-1">
            <h3 className="font-default text-xs uppercase tracking-[0.18em] text-muted-foreground mb-6">
              Contact
            </h3>
            <ul className="space-y-3">
              {contactLinks.map((link, i) => <li key={link.label} data-index={i}>
                  <Link to={link.href} className="font-default text-[18px] text-foreground hover:text-primary transition-colors relative inline-block after:content-[''] after:absolute after:left-0 after:bottom-0 after:h-px after:w-0 after:bg-primary hover:after:w-full after:transition-all after:duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="relative mt-20 mb-8 flex items-center">
          <div className="flex-1 h-px bg-border" />
          <span className="font-default text-2xl text-muted-foreground px-4 leading-none">
            ·
          </span>
          <div className="flex-1 h-px bg-border" />
        </div>

        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6">
          <p className="font-default text-[11px] uppercase tracking-[0.15em] text-muted-foreground text-center md:text-left">© 2026 JOANNE GLOW STUDIO · ALL RIGHTS RESERVED</p>

          <p className="font-default text-[11px] uppercase tracking-[0.15em] text-muted-foreground text-center">
            New York, NY · 40.7128° N
          </p>

          <div className="flex items-center gap-4">
            <Link to="#" className="font-default text-[11px] uppercase tracking-[0.15em] text-muted-foreground hover:text-primary transition-colors">
              Privacy
            </Link>
            <span className="font-default text-[11px] text-muted-foreground">·</span>
            <Link to="#" className="font-default text-[11px] uppercase tracking-[0.15em] text-muted-foreground hover:text-primary transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </section>;
}